import React from 'react';

import Alert from '@mui/material/Alert';
import Snackbar from '@mui/material/Snackbar';

function Notification({ message, severity, open, onClose, duration }) {
    const [isOpen, setIsOpen] = React.useState(open);

    React.useEffect(() => {
        setIsOpen(open);
    }, [open]);

    const handleClose = () => {
        setIsOpen(false);
        onClose(false);
    }

    let borderColor;
    switch (severity) {
        case 'error':
            borderColor = '#f44336';
            break;
        case 'warning':
            borderColor = '#ff9800';
            break;
        case 'info':
            borderColor = '#2196f3';
            break;
        case 'success':
            borderColor = '#4caf50';
            break;
        default:
            borderColor = '#2196f3';
    }

    return (
        <Snackbar
            open={isOpen}
            autoHideDuration={duration || 2500}
            onClose={handleClose}
            sx={{
                border: '0px solid !important',
                borderColor: `${borderColor} !important`
            }}
            anchorOrigin={{
                vertical: 'bottom',
                horizontal: 'center',
            }}
        >
            <Alert severity={severity}>{message}</Alert>
        </Snackbar>
    );
}

export default Notification;